/** Capas de atmósfera Deep Space (nebulosas + estrellas). Sutiles sobre fondo oscuro; el color vive en paneles locales. */
export function deepSpaceBackgroundImageLayers(bg2: string): string {
  const light = bg2.toLowerCase() === '#f1f5f9'

  if (light) {
    return [
      `radial-gradient(ellipse 85% 65% at 18% 12%, rgba(124, 58, 237, 0.14), transparent 55%)`,
      `radial-gradient(ellipse 75% 55% at 82% 75%, rgba(59, 130, 246, 0.12), transparent 50%)`,
      `radial-gradient(ellipse 70% 50% at 48% 40%, rgba(13, 148, 136, 0.1), transparent 52%)`,
      `linear-gradient(180deg, rgba(241, 245, 249, 0.95) 0%, rgba(241, 245, 249, 0.4) 100%)`
    ].join(', ')
  }

  return [
    `radial-gradient(2px 2px at 6% 10%, rgba(255, 255, 255, 0.62), transparent)`,
    `radial-gradient(2px 2px at 14% 38%, rgba(255, 255, 255, 0.48), transparent)`,
    `radial-gradient(1.5px 1.5px at 22% 18%, rgba(200, 230, 255, 0.55), transparent)`,
    `radial-gradient(2px 2px at 34% 62%, rgba(255, 255, 255, 0.4), transparent)`,
    `radial-gradient(2.5px 2.5px at 48% 28%, rgba(255, 255, 255, 0.52), transparent)`,
    `radial-gradient(1.5px 1.5px at 58% 78%, rgba(255, 255, 255, 0.34), transparent)`,
    `radial-gradient(2px 2px at 68% 12%, rgba(255, 255, 255, 0.44), transparent)`,
    `radial-gradient(2px 2px at 78% 55%, rgba(180, 220, 255, 0.5), transparent)`,
    `radial-gradient(1.5px 1.5px at 88% 22%, rgba(255, 255, 255, 0.38), transparent)`,
    `radial-gradient(2px 2px at 92% 68%, rgba(255, 255, 255, 0.46), transparent)`,
    `radial-gradient(2px 2px at 3% 85%, rgba(255, 255, 255, 0.32), transparent)`,
    `radial-gradient(2.5px 2.5px at 96% 88%, rgba(200, 230, 255, 0.42), transparent)`,
    `radial-gradient(ellipse 120% 95% at 18% 8%, rgba(124, 58, 237, 0.26), transparent 48%)`,
    `radial-gradient(ellipse 100% 85% at 88% 78%, rgba(37, 99, 235, 0.18), transparent 45%)`,
    `radial-gradient(ellipse 90% 75% at 48% 36%, rgba(0, 232, 163, 0.12), transparent 50%)`,
    `radial-gradient(ellipse 130% 100% at 50% -15%, rgba(94, 234, 212, 0.06), transparent 42%)`,
    `linear-gradient(180deg, rgba(16, 185, 129, 0.1) 0%, rgba(1, 4, 15, 0) 38%)`,
    `linear-gradient(180deg, rgba(1, 4, 15, 0.78) 0%, rgba(1, 4, 15, 0.62) 42%, rgba(1, 4, 15, 0.38) 100%)`,
    `linear-gradient(180deg, rgba(1, 4, 15, 0) 55%, rgba(1, 4, 15, 0.88) 100%)`
  ].join(', ')
}
